import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useSelector, useDispatch } from "react-redux";

import { fetchOffers } from "../../redux/slice/offers/offers";

import "./Offer.scss";
import Header from "../../component/header/Header";
import Aside from "../../component/aside/Aside";
import Footer from "../../component/footer/Footer2";
import SortDropdown from "../../component/SortDropdown";
import Filters from "../../component/Filters";
import Loader from "../../component/loader/Loader";
import DownIcon from "../../assets/images/down.svg";
import User from "../../assets/images/User-02.png";
import NoDataComp from "../../component/NoDataComp";

const Offer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("v-pills-home");
  const { offersData, loading } = useSelector((state) => state.offers);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [showAllOffers, setShowAllOffers] = useState(false);
  const offersToShow = showAllOffers ? filteredData : filteredData?.slice(0, 6);
  const NoOfferText = "COMING SOON";

  const baseUrl = "https://d3kj4cuhkbykh5.cloudfront.net";
  const breadcrumbs = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#1D1D1B",
      }}
    >
      Home
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#1D1D1B",
      }}
    >
      Offers
    </Typography>,
  ];
  const breadcrumbsMobile = [
    <Link
      underline="hover"
      key="1"
      color="inherit"
      onClick={() => navigate("/home")}
      sx={{
        fontSize: "12px",
        fontWeight: "300",
        lineHeight: "12px",
        color: "#A9A9A9",
      }}
    >
      Home
    </Link>,
    <Typography
      key="3"
      sx={{
        fontSize: "12px",
        fontWeight: "700",
        lineHeight: "15px",
        color: "#ffffff",
      }}
    >
      Offers
    </Typography>,
  ];

  useEffect(() => {
    dispatch(fetchOffers());
  }, []);

  useEffect(() => {
    if (offersData?.length > 0 && selectedFilters?.length > 0) {
      const result = offersData.filter((el) => {
        if (selectedFilters?.includes(el?.attributes?.Filter)) {
          return el;
        }
      });

      setFilteredData(result);
    } else {
      setFilteredData(offersData);
    }
  }, [offersData, selectedFilters]);

  const handleSeeMoreToggle = () => {
    setShowAllOffers((prev) => !prev);
  };

  return (
    <>
      <Header activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="home">
        <div
          className="container pt-5 in-mobile desktop_content"
          style={{ paddingBottom: "40px" }}
        >
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbs}
          </Breadcrumbs>
        </div>
        <div className="sidebar">
          <div className="container">
            <div className="row">
              <div className="col-lg-4  col-md-4 desktop_content">
                <Aside activeTab={activeTab} setActiveTab={setActiveTab} />
              </div>
              <div className="col-lg-8 col-md-8 in-mobile">
                <div className="tabs">
                  <div className="tab_content">
                    <div className="tab-content" id="v-pills-tabContent">
                      <div
                        className=""
                        id="v-pills-offers"
                        role="tabpanel"
                        aria-labelledby="v-pills-offers-tab"
                        tabIndex="0"
                      >
                        <div className="container1">
                          <div className="title-container">
                            <div className="container pt-5 in-mobile mobile_content">
                              <Breadcrumbs
                                separator={
                                  <NavigateNextIcon
                                    fontSize="small"
                                    sx={{ color: "#A9A9A9" }}
                                  />
                                }
                                aria-label="breadcrumb"
                              >
                                {breadcrumbsMobile}
                              </Breadcrumbs>
                            </div>
                            <h2>Offers Nearby Me</h2>
                          </div>
                          <div className="filter-container">
                            {offersData?.length > 0 && <div className="filters">
                              <Filters
                                selectedFilters={selectedFilters}
                                setSelectedFilters={setSelectedFilters}
                              />
                            </div>}
                            {/* <div>
                              <SortDropdown />
                            </div> */}
                          </div>
                          <div className="offers-container">
                            {offersToShow?.length > 0 ?
                            offersToShow?.map((offer) => (
                              <div className="offer" key={offer?.id} onClick={() => {
                                navigate("/store-page", {
                                  state: offer?.attributes,
                                });
                              }}>
                                <div
                                  style={{
                                    backgroundImage: offer?.attributes?.Offer_Image
                                      ? `url(${baseUrl}${offer?.attributes?.Offer_Image?.data?.attributes?.url})`
                                      : `url(${User})`,
                                  }}
                                  className="offer1"
                                >
                                  <div className="gardient">
                                    <p>{offer?.attributes?.Offer_Name}</p>
                                  </div>
                                </div>
                                <div className="offer2">
                                  <p>{offer?.attributes?.Description}</p>
                                  <img
                                    src={
                                      offer?.attributes?.thumbnail_image
                                        ? (baseUrl + offer?.attributes?.thumbnail_image?.data?.attributes?.url)
                                        : User
                                    }
                                    alt="offer logo"
                                    width={42}
                                    height={42}
                                  />
                                </div>
                              </div>
                            ))
                          : (loading ? null : <NoDataComp bgColor="#f7f3eb" text={NoOfferText} />)}
                          </div>

                          {filteredData.length > 6 && (
                            <div className="button-container">
                              <button
                                className="offers-btn"
                                onClick={handleSeeMoreToggle}
                              >
                                <p>
                                  {showAllOffers ? "Show Less" : "See More"}
                                </p>
                                <img
                                  src={DownIcon}
                                  alt="down icon"
                                  style={{
                                    rotate: `${
                                      showAllOffers ? "180deg" : "360deg"
                                    }`,
                                  }}
                                />
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footerMobPending"></div>
      {loading && offersData?.length === 0 ? (
        <div className="spinner_table_height">
          <Loader color="black" open={loading} />
        </div>
      ) : null}
      <Footer selected="offers" />
    </>
  );
};

export default Offer;
